$('.change-color-notifications').click(function() {
  if ($(this).hasClass('bg-primary-unread')) {
    $(this).removeClass('bg-primary-unread');
    $(this).addClass('bg-content-scheme');
  }
})
